import { Link } from "gatsby";
import React from "react";
import { GatsbyLinkProps } from "./gatsbyLink.types";

export const GatsbyLink = ({to,className,children}:GatsbyLinkProps) => {
  return <Link to={to} className={className} activeClassName="active" draggable={false} onDragStart={(e) => {e.preventDefault()}}>{children}</Link>
};